import { render, staticRenderFns } from "./KuesionerKompetensi.vue?vue&type=template&id=8d67e154&lang=html&"
import script from "./KuesionerKompetensi.vue?vue&type=script&lang=js&"
export * from "./KuesionerKompetensi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports